import angular from 'angular';

angular.module('commonServices').factory('lockFactory', ['$q', lockFactory]);

function lockFactory($q) {
  var locks = {};
  return {
    create: function(key, callback) {
      //Validation
      if (!key) throw new Error('The key is requred');
      if (typeof key !== 'string') throw new Error('The key must be a string');
      if (!angular.isFunction(callback)) throw new Error('Callback must be a function');
      //Chekc if lock already exists
      if (locks[key]) return locks[key].promise; //Return lock promise

      //Create new lock promise
      locks[key] = $q.defer();
      //Call callback function
      $q.when(callback())
        .then(locks[key].resolve, locks[key].reject) //Resolve/reject lock when callback is finised
        .finally(function() {
          //Clear the lock
          locks[key] = null;
        });

      return locks[key].promise;
    },
  };
}
